import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router-dom";
import { toast } from "react-hot-toast";
import AsyncSelect from "react-select/async";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import axios from "axios";
import { Country, State, City } from 'country-state-city';

// My components
import SecCard from "../../components/common/SecCard";
import BackButton from "../../components/common/BackButton";

// My css
import regisCss from "../../css/user/regis-page.module.css";
import "../../css/user/regis-page.module.css";

import { SERVER_ORIGIN, vars, validation } from "../../utilities/constants";
import { isRegisFormValid, getManageStudentsPath } from "../../utilities/helper_functions";

const GreenMsg = (props) => {
    return (
        <>
            {" "}
            |{" "}
            <span style={{ color: "green", fontWeight: "600" }}>
                {props.children}
            </span>
        </>
    );
};

const RedMsg = (props) => {
    return (
        <>
            {" "}
            |{" "}
            <span style={{ color: "red", fontWeight: "600" }}>
                {props.children}
            </span>
        </>
    );
};

// const YearPicker = ({ selectedYear, handleYearChange }) => {
//     const handleChange = (date) => {
//         if (date) {
//             handleYearChange({ target: { name: "passOutYear", value: date.getFullYear().toString() } });
//         }
//     };

//     return (
//         <DatePicker
//             selected={selectedYear ? new Date(selectedYear, 0) : null}
//             onChange={handleChange}
//             showYearPicker
//             dateFormat="yyyy"
//             className={`${regisCss.regisInput} w-100`}
//             placeholderText="Select your passout year"


//         />
//     );
// };
// // dropdown year picker
// const YearPicker = ({ selectedYear, handleYearChange }) => {
//     const currentYear = new Date().getFullYear();
//     const years = Array.from({ length: 10 }, (_, i) => ({
//         value: currentYear + i,
//         label: (currentYear + i).toString(),
//     }));

//     return (
//         <Select
//             options={years}
//             value={years.find((y) => y.value === parseInt(selectedYear))}
//             onChange={(option) =>
//                 handleYearChange({
//                     target: { name: "passOutYear", value: option.value.toString() },
//                 })
//             }
//             placeholder="Select passout year"
//             styles={{
//                 control: (base) => ({
//                     ...base,
//                     borderRadius: "8px",
//                     borderColor: "#ccc",
//                     boxShadow: "none",
//                     "&:hover": { borderColor: "#3b82f6" },
//                 }),
//             }}
//         />
//     );
// };

const YearPicker = ({ selectedYear, handleYearChange }) => {
    const currentYear = new Date().getFullYear();

    const handleChange = (date) => {
        if (date) {
            handleYearChange({
                target: { name: "passOutYear", value: date.getFullYear().toString() },
            });
        }
    };

    return (
        <DatePicker
            selected={selectedYear ? new Date(selectedYear, 0) : null}
            onChange={handleChange}
            showYearPicker
            dateFormat="yyyy"
            // className="w-100 regisInput"
            className={`${regisCss.regisInput} w-100`}

            placeholderText="Select your passout year"
            minDate={new Date(currentYear, 0, 1)} // ✅ restrict past years
        />
    );
};
const UserRegis = (props) => {
    const { _id } = useParams()
    const [searchParams] = useSearchParams();

    const tabFromUrl = searchParams.get('tab');
    const [activeTab, setActiveTab] = useState(tabFromUrl || 'institute'); // Add tab state
    const [instituteType, setInstituteType] = useState(tabFromUrl || null); // Track institute type based on URL

    const [selectedOption, setSelectedOption] = useState(null);
    const [defaultOptions, setDefaultOptions] = useState([]);

    // Move state-related declarations to the top
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    // edit page start
    const [formData, setFormData] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isEdit = queryParams.get("edit") === "true";
    // const { id: userId } = useParams();
    const userId = queryParams.get("id"); // ✅ Get id from query params

    useEffect(() => {
        if (isEdit && userId) {
            fetchStudentData();
        }
    }, [isEdit, userId]);

    const fetchStudentData = async () => {
        try {
            // const res = await fetch(`${SERVER_ORIGIN}/api/student/auth/${userId}`, {
            //     headers: {
            //         "auth-token": sessionStorage.getItem("token"),
            //     },
            // });
            const res = await fetch(
                `${SERVER_ORIGIN}/api/student/auth/users/${userId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        //Authorization: `Basic ${basicAuth}`,
                        "auth-token": sessionStorage.getItem("token"),
                    },
                }
            );
            const data = await res.json();
            console.log("data:", data);
            if (res.ok) {
                setRegisForm(data?.user);
                // ✅ Set selectedOption for AsyncSelect
                setSelectedOption({
                    label: data?.user?.collegeName,
                    value: data?.user?.createdBy,
                    state: data?.user?.state,
                    city: data?.user?.city
                });

                // ✅ Also set selectedState and selectedCity
                const stateOption = states.find(state => state.label === data?.user?.state);
                if (stateOption) {
                    setSelectedState(stateOption);
                    const stateCities = City.getCitiesOfState('IN', stateOption.value);
                    setCities(stateCities.map(city => ({ label: city.name, value: city.name })));
                    setSelectedCity({ label: data?.user?.city, value: data?.user?.city });
                }
            } else {
                toast.error(data.statusText || "Failed to fetch student data");
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // end edit page 

    const loadOptions = async (inputValue, callback) => {
        try {
            const params = {
                search: inputValue,
                page: 1,
                limit: 10,
                sortBy: "name",
                sortType: "asc",
                isThalir: activeTab === 'thalir' ? 'true' : 'false'
            };

            // Conditionally add the id parameter if _id is not 0
            if (_id !== 'no_id') {
                params.id = _id;
            }
            const response = await axios.get(`${SERVER_ORIGIN}/api/institute/auth/institute/all`, {
                params
            });
            const options = response.data.filteredInstitutes.map(institute => ({
                label: institute.name,
                value: institute._id,
                state: institute.state,
                city: institute.city
            }));
            callback(options);
        } catch (error) {
            console.error("Error fetching institutes", error);
        }
    };

    useEffect(() => {
        const fetchDefaultOptions = async () => {
            try {
                const response = await axios.get(`${SERVER_ORIGIN}/api/institute/auth/institute/all`, {
                    params: {
                        search: '',
                        page: 1,
                        limit: 5,
                        sortBy: "name",
                        sortType: "asc",
                        id: _id,
                        isThalir: activeTab === 'thalir' ? 'true' : 'false'
                    }
                });
                const options = response.data.filteredInstitutes.map(institute => ({
                    label: institute.name,
                    value: institute._id,
                    state: institute.state,
                    city: institute.city
                }));
                setDefaultOptions(options);
            } catch (error) {
                console.error("Error fetching default options", error);
            }
        };

        fetchDefaultOptions();
    }, [_id, activeTab]); // Add activeTab to dependencies

    // Separate useEffect for auto-selection when states are available
    useEffect(() => {
        if (_id && _id !== 'no_id' && defaultOptions.length === 1 && states.length > 0) {
            const selectedInstitute = defaultOptions[0];
            setSelectedOption(selectedInstitute);

            // Auto-populate state and city as well
            const stateOption = states.find(state => state.label === selectedInstitute.state);
            if (stateOption) {
                setSelectedState(stateOption);
                const stateCities = City.getCitiesOfState('IN', stateOption.value);
                setCities(stateCities.map(city => ({ label: city.name, value: city.name })));
                const cityOption = { label: selectedInstitute.city, value: selectedInstitute.city };
                setSelectedCity(cityOption);
            }

            // Update form data
            setRegisForm(prevForm => ({
                ...prevForm,
                collegeName: selectedInstitute.label,
                state: selectedInstitute.state,
                city: selectedInstitute.city,
                createdBy: selectedInstitute.value, // Set createdBy to the auto-selected institute's _id
                isPublicRegistration: isPublicRegistration
                // isPublicRegistration: true // Explicitly set for auto-selected institutes
            }));
        }
    }, [_id, defaultOptions, states]); // This useEffect runs when defaultOptions and states are both ready

    // Reset form when switching tabs
    useEffect(() => {
        setSelectedOption(null);
        setSelectedState(null);
        setSelectedCity(null);
        setCities([]);
        setRegisForm(prevForm => ({
            ...prevForm,
            collegeName: "",
            state: "",
            city: "",
            createdBy: (_id && _id !== 'no_id') ? _id : handelCreatedBy(), // Reset createdBy to original value
            isThalir: activeTab === 'thalir' // Update isThalir flag when tab changes
        }));
    }, [activeTab]);

    // Handle URL tab parameter for public links
    useEffect(() => {
        if (tabFromUrl) {
            // If tab parameter is in URL, set it as the institute type (for public links)
            setInstituteType(tabFromUrl);
            setActiveTab(tabFromUrl);
        } else if (_id && _id !== 'no_id') {
            // Only fetch institute details if no tab parameter (logged-in users)
            const getInstituteDetails = async () => {
                try {
                    const response = await fetch(`${SERVER_ORIGIN}/api/institute/auth/check-terms`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'auth-token': sessionStorage.getItem('token'),
                        },
                        body: JSON.stringify({ _id })
                    });

                    if (response.ok) {
                        const result = await response.json();
                        const isThalir = result.data?.isThalir || false;
                        setInstituteType(isThalir ? 'thalir' : 'institute');
                        setActiveTab(isThalir ? 'thalir' : 'institute');
                    }
                } catch (error) {
                    console.error('Error fetching institute details:', error);
                }
            };

            getInstituteDetails();
        }
    }, [_id, tabFromUrl]);

    const isPublicRegistration = searchParams.get('public') === 'true';

    console.log("isPublicRegistration: ", isPublicRegistration);
    const [regisForm, setRegisForm] = useState({
        userId: "",
        email: "",
        fName: "",
        mName: "",
        lName: "",
        collegeName: "",
        region: "",
        gender: "",
        branch: "",
        phone: "",
        addLine1: "",
        addLine2: "",
        city: "",
        pincode: "",
        country: "India",
        state: "",
        passOutYear: "",
        createdBy: (_id && _id !== 'no_id') ? _id : handelCreatedBy(),
        isPublicRegistration: isPublicRegistration,
        // isPublicRegistration: _id && _id !== 'no_id', // Flag for public registration via shared link
        isThalir: activeTab === 'thalir', // Add isThalir flag based on active tab
        // privacyAcknowledged: false,
    });
    function handelCreatedBy() {
        if (sessionStorage.getItem('token') !== null) {
            return sessionStorage.getItem('_id')
        } else {
            return ""
        }
    }
    const navigate = useNavigate();
    const [isRegistering, setIsRegistering] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(false);

    const [isUserIdAvailable, setIsUserIdAvailable] = useState(false);
    const [wasUserIdAvailabilityChecked, setWasUserIdAvailabilityChecked] = useState(false);
    let userIdAvailabilityCheckTimer = null;
    const userIdAvailabilityCheckDelayInMilliSec = 1000;

    const checkUserIdAvailability = async () => {
        if (regisForm.userId === "") {
            return;
        }

        try {
            const userId = "utkarsh@troology.in";
            const userPassword = "Redhood@23"
            const basicAuth = btoa(`${userId}:${userPassword}`);
            const response = await fetch(`${SERVER_ORIGIN}/api/student/auth/check-userid-availability`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${basicAuth}`,
                },
                body: JSON.stringify({ userId: regisForm.userId }),
            });

            const result = await response.json();
            if (response.status >= 400 && response.status < 600) {
                if (response.status === 500) {
                    toast.error(result.statusText);
                }
            } else if (response.ok && response.status === 200) {
                setWasUserIdAvailabilityChecked(true);
                setIsUserIdAvailable(result.isUserIdAvailable);
            }
        } catch (err) {
            console.error(err.message);
        }
    };
    const handleUpdateClick = async () => {
        if (isBtnDisabled) return;
        setIsBtnDisabled(true);

        const { isValid, desc } = isRegisFormValid(regisForm);
        if (!isValid) {
            toast.error(desc);
            setIsBtnDisabled(false);
            return;
        }

        try {
            setIsRegistering(true);
            const userIds = "utkarsh@troology.in";
            const userPassword = "Redhood@23";
            const basicAuth = btoa(`${userIds}:${userPassword}`);

            const response = await fetch(`${SERVER_ORIGIN}/api/student/auth/update/${userId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${basicAuth}`,
                },
                body: JSON.stringify(regisForm),
            });

            const result = await response.json();

            setIsRegistering(false);
            setIsBtnDisabled(false);

            // if (response.ok) {
            //     toast.success(result.statusText || "Student updated successfully");
            //     navigate("admin/users/all");
            // } else {
            //     toast.error(result.statusText || "Failed to update");
            // }
            if (response.ok) {
                toast.success(result.statusText);

                const userType = sessionStorage.getItem("userType");

                if (userType === "admin") {
                    navigate("/admin/users/all");
                } else if (userType === "institute") {
                    navigate("/institute/students/all");
                } else {
                    navigate("/"); // fallback if unknown type
                }
            } else {
                toast.error(result.statusText || "Failed to update");
            }

        } catch (err) {
            console.error(err.message);
            setIsBtnDisabled(false);
        }
    };

    const handleRegisterClick = async () => {
        if (isBtnDisabled) return; // Prevent double-clicks
        setIsBtnDisabled(true); // Disable button immediately

        const { isValid, desc } = isRegisFormValid(regisForm);
        if (!isValid) {
            toast.error(desc);
            setIsBtnDisabled(false); // Re-enable button if validation fails
            return;
        }

        try {
            setIsRegistering(true);
            setIsBtnDisabled(true);
            const userId = "utkarsh@troology.in";
            const userPassword = "Redhood@23"
            const basicAuth = btoa(`${userId}:${userPassword}`);

            const response = await fetch(`${SERVER_ORIGIN}/api/student/auth/register`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${basicAuth}`,
                },
                body: JSON.stringify(regisForm),
            });

            const result = await response.json();

            setIsRegistering(false);
            setIsBtnDisabled(false);

            // if (response.ok && response.status === 200) {
            //     toast.success(result.statusText);
            //     if (sessionStorage.getItem("userType")) {
            //         navigate(!_id ? "/institute/students/all" : `/institute-students/${_id}`);
            //         // window.location.reload()
            //     } else {
            //         navigate("/");
            //     }

            // } else {
            //     toast.error(result.statusText);
            // }
            if (response.ok && response.status === 200) {
                toast.success(result.statusText);

                // Extract _id safely (if backend returns it)
                const _id = result?.data?._id || result?._id || null;

                if (sessionStorage.getItem("userType")) {
                    // Redirect based on _id presence
                    if (_id) {
                        // navigate(`/institute-students/${_id}`);
                        navigate(-1);
                    } else {
                        navigate(-1);

                        // navigate(`/institute/students/all?tab=${activeTab}`);
                    }
                } else {
                    navigate("/");
                }
            } else {
                toast.error(result.statusText);
            }

        } catch (err) {
            console.error(err.message);
            setIsBtnDisabled(false); // Re-enable button on error
        }
    };

    useEffect(() => {
        const indianStates = State.getStatesOfCountry('IN');
        setStates(indianStates.map(state => ({ label: state.name, value: state.isoCode })));
    }, []);

    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        const stateCities = City.getCitiesOfState('IN', selectedOption.value);
        setCities(stateCities.map(city => ({ label: city.name, value: city.name })));
        setSelectedCity(null);
        setRegisForm(prevForm => ({ ...prevForm, state: selectedOption.label, city: '' }));
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
        setRegisForm(prevForm => ({ ...prevForm, city: selectedOption.label }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'email') {
            regisForm.userId = value; // update userId when email changes
        }
        setRegisForm({ ...regisForm, [e.target.name]: e.target.value });

    };

    const handleUserIdChange = (e) => {
        handleInputChange(e);
        setWasUserIdAvailabilityChecked(false);
        clearTimeout(userIdAvailabilityCheckTimer);
        userIdAvailabilityCheckTimer = setTimeout(checkUserIdAvailability, userIdAvailabilityCheckDelayInMilliSec);
    };
    const UserIdAvailabilityMsg = (props) => {
        return wasUserIdAvailabilityChecked ? (
            isUserIdAvailable ? (
                <GreenMsg>Available</GreenMsg>
            ) : (
                <RedMsg>Not available</RedMsg>
            )
        ) : null;
    };
    return (
        <div className={regisCss.outerDiv}>
            <SecCard>
                {/* Only show back button for authenticated users */}
                {sessionStorage.getItem('token') && (
                    <BackButton text="Back to Manage Students" customPath={getManageStudentsPath()} />
                )}
                <h2 className="text-ff1">{activeTab === 'institute' ? 'YUVA Student Registration' : 'Thalir Student Registration'}</h2>

                <div className="text-ff2" autoComplete="on">
                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="email">
                            Email <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email"
                            value={regisForm.email}
                            onChange={handleInputChange}
                            autoComplete="on"
                            required
                            disabled={isEdit} // ✅ Disable if editing

                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="fName">
                            First name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="fName"
                            name="fName"
                            placeholder="Enter your first name"
                            autoComplete="on"
                            maxLength={validation.authForm.fName.maxLen}
                            value={regisForm.fName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="mName">
                            Middle name
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="mName"
                            name="mName"
                            placeholder="Enter your middle name"
                            autoComplete="on"
                            maxLength={validation.authForm.mName.maxLen}
                            value={regisForm.mName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="lName">
                            Last name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="lName"
                            name="lName"
                            placeholder="Enter your last name"
                            autoComplete="on"
                            maxLength={validation.authForm.lName.maxLen}
                            value={regisForm.lName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label
                            className={regisCss.regisLabel}
                            htmlFor="collegeName"
                        >
                            {activeTab === 'institute' ? 'Institute Name' : 'School Name'} <span style={{ color: "red" }}>*</span>
                        </label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={loadOptions}
                            defaultOptions={defaultOptions}
                            onChange={(selectedOption) => {
                                if (selectedOption) {
                                    const stateOption = states.find(state => state.label === selectedOption.state);
                                    setSelectedState(stateOption);

                                    const stateCities = City.getCitiesOfState('IN', stateOption.value);
                                    setCities(stateCities.map(city => ({ label: city.name, value: city.name })));

                                    const cityOption = { label: selectedOption.city, value: selectedOption.city };
                                    setSelectedCity(cityOption);

                                    setRegisForm(prevForm => ({
                                        ...prevForm,
                                        collegeName: selectedOption.label,
                                        state: selectedOption.state,
                                        city: selectedOption.city,
                                        createdBy: selectedOption.value // Set createdBy to the selected institute's _id
                                    }));
                                    setSelectedOption(selectedOption);
                                }
                            }}
                            isDisabled={isEdit}   // 👈 disable dropdown when editing
                            value={selectedOption}
                            placeholder={`Enter your ${activeTab === 'institute' ? 'institute' : 'school'} name`}
                        />

                    </div>
                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="branch">
                            Branch  <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="branch"
                            name="branch"
                            placeholder="Enter your branch"
                            autoComplete="on"
                            maxLength={validation.authForm.branch.maxLen}
                            value={regisForm.branch}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="passOutYear">
                            Passout Year  <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <div className="w-100">
                            <YearPicker
                                selectedYear={regisForm.passOutYear}
                                handleYearChange={handleInputChange}
                                className='w-100'
                            />
                        </div>
                    </div>
                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="phone">
                            Phone <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="tel"
                            id="phone"
                            name="phone"
                            placeholder="Enter your phone number"
                            autoComplete="on"
                            maxLength={validation.authForm.phone.maxLen}
                            value={regisForm.phone}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="gender">
                            Gender
                            {/* <span style={{ color: "red" }}>*</span> */}
                        </label>
                        <select
                            id="gender"
                            className={`${regisCss.regisInput} py-0`}
                            name="gender"
                            value={regisForm.gender}
                            onChange={handleInputChange}
                        >
                            <option value="">Select Gender</option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                            <option value="O">Prefer not to say</option>
                        </select>
                    </div>
                    <div style={{ marginBottom: '0.8rem' }}>
                        <label className={regisCss.regisLabel} htmlFor="country">Country <span style={{ color: 'red' }}>*</span></label>
                        <input
                            id="country"
                            className={regisCss.regisInput}
                            value={"India"}
                            readOnly
                            isDisabled
                        >
                        </input>
                    </div>
                    <div style={{ marginBottom: '0.8rem' }}>
                        <label className={regisCss.regisLabel} htmlFor="state">State <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            id="state"
                            // className={regisCss.regisInput}
                            options={states}
                            value={selectedState}
                            onChange={handleStateChange}
                            isDisabled
                            placeholder="Select institue"
                        />
                    </div>
                    <div style={{ marginBottom: '0.8rem' }}>
                        <label className={regisCss.regisLabel} htmlFor="city">City <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            id="city"
                            // className={regisCss.regisInput}
                            options={cities}
                            value={selectedCity}
                            onChange={handleCityChange}
                            isDisabled
                            placeholder="Select institue"
                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label
                            className={regisCss.regisLabel}
                            htmlFor="pincode"
                        >
                            Pincode
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="pincode"
                            name="pincode"
                            placeholder="Enter your city's pincode (optional, 6 digits)"
                            autoComplete="on"
                            maxLength={6}
                            pattern="[0-9]{6}"
                            value={regisForm.pincode}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9]/g, '');
                                if (value.length <= 6) {
                                    handleInputChange({ target: { name: 'pincode', value } });
                                }
                            }}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label
                            className={regisCss.regisLabel}
                            htmlFor="addLine1"
                        >
                            Address line 1
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="addLine1"
                            name="addLine1"
                            placeholder="Address line 1"
                            autoComplete="on"
                            maxLength={validation.authForm.addLine1.maxLen}
                            pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                            value={regisForm.addLine1}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div style={{ marginBottom: "0.8rem" }}>
                        <label
                            className={regisCss.regisLabel}
                            htmlFor="addLine2"
                        >
                            Address line 2
                        </label>
                        <input
                            className={regisCss.regisInput}
                            type="text"
                            id="addLine2"
                            name="addLine2"
                            placeholder="Address line 2"
                            autoComplete="on"
                            maxLength={validation.authForm.addLine2.maxLen}
                            value={regisForm.addLine2}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* <div style={{ marginBottom: "0.8rem" }}>
                        <label className={regisCss.regisLabel} htmlFor="privacyAcknowledged">
                            Privacy acknowledgement <span style={{ color: "red" }}>*</span>
                        </label>
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                            <input
                                type="checkbox"
                                id="privacyAcknowledged"
                                name="privacyAcknowledged"
                                checked={regisForm.privacyAcknowledged === true}
                                onChange={(e) =>
                                    setRegisForm({ ...regisForm, privacyAcknowledged: e.target.checked })
                                }
                                style={{ marginTop: 6 }}
                            />
                            <span style={{ fontSize: "0.95rem", color: "#374151" }}>
                                I agree to receive updates, promotional emails, and messages from CII Young Indians.
                            </span>
                        </div>
                    </div> */}

                    {/* <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <button
                            onClick={handleRegisterClick}
                            className={regisCss.regisBtn}
                            disabled={isBtnDisabled}
                        >
                            {isRegistering ? "Registering ..." : "Register"}
                        </button>
                    </div> */}
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <button
                            onClick={isEdit ? handleUpdateClick : handleRegisterClick}
                            className={regisCss.regisBtn}
                            disabled={isBtnDisabled}
                        >
                            {isRegistering
                                ? isEdit
                                    ? "Updating..."
                                    : "Registering..."
                                : isEdit
                                    ? "Update"
                                    : "Register"}
                        </button>
                    </div>

                </div>
            </SecCard>
        </div>
    );
};

export default UserRegis;
